export const BluebeardAudioData = {
    voiceover: {
        id: "bluebeard-voiceover",
    },
    global: {
        tempo: 123,
        signature: [4, 4],
    },
    noise: {
        volume: -40,
        filterFreqency: "8m",
        type: "white",
    },
    sharedLoops: [
        {
            name: "accordion1",
            samplePool: ["accordion1"],
            length: "8m",
            volume: -12,
        },
        {
            name: "accordion2",
            samplePool: ["accordion2"],
            length: "4m",
            volume: -12,
        },
        {
            name: "song",
            samplePool: ["drunken-song-dry-8m", "drunken-song-rev-8m"],
            length: "8m",
        },
        {
            name: "clock",
            samplePool: ["clock-4m"],
            length: "4m",
        },
        {
            name: "chains",
            samplePool: ["chains-4m"],
            length: "4m",
        },
        {
            name: "axe",
            samplePool: ["axe-8m"],
            length: "8m",
        },
        {
            name: "footsteps",
            samplePool: ["footsteps-6m"],
            length: "6m",
        },
    ],
    scenes: [
        // 1. House Exterior #1
        {
            name: "House Exterior #1",
            tracks: [
                { group: "accordion1" },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 2,
        },
        // 2. House Exterior #2
        {
            name: "House Exterior #2",
            tracks: [
                // Could we drop everything except "name" if it was repeated?
                { group: "accordion1" },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 2,
        },
        // 3. House Distant / Bluebeard cloud
        {
            name: "House Distant / Bluebeard cloud",
            tracks: [
                { group: "accordion2" },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 2,
        },
        // 4. House Interior distant
        {
            name: "House Interior distant",
            tracks: [
                { group: "accordion2" },
                { group: "song", volume: -128 },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 2,
        },
        // 5. Top floor
        {
            name: "Top floor",
            tracks: [
                { group: "song", volume: -12 },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 2,
        },
        // 6. Grandfather clock
        {
            name: "Grandfather clock",
            tracks: [
                { group: "clock", volume: -18 },
                { group: "song", volume: -14 },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 2,
        },
        // 7. Bottom floor
        {
            name: "Bottom floor",
            tracks: [
                { group: "clock", volume: -24 },
                { group: "song", volume: -16 },
                { group: "chains", volume: -16 },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 2,
        },
        // 8. Chains
        {
            name: "Chains",
            tracks: [
                { group: "chains", volume: -9 },
                { group: "song", volume: -24 },
                { group: "axe", volume: -18 },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 2,
        },
        // 9. Axe
        {
            name: "Axe",
            tracks: [
                { group: "chains", volume: -16 },
                { group: "axe", volume: -3 },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 2,
        },
        // 10. Stairs
        {
            name: "Stairs",
            tracks: [
                { group: "axe", volume: -12 },
                { group: "footsteps", volume: -6 },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 2,
        },
        // 11. Room of death
        {
            name: "Room of death",
            tracks: [
                { group: "clock", volume: -24 },
                { group: "chains", volume: -20 },
                { group: "footsteps", volume: -16 },
                { group: "song", volume: -18, sampleIndex: [1] },
                { group: "axe", volume: -9 },
                {
                    samplePool: ["boom-8m"],
                    length: "8m",
                    volume: -18,
                    velocity: 0.8,
                },
                {
                    samplePool: ["bass-4m"],
                    length: "4m",
                    volume: -16,
                    velocity: 0.5,
                },
            ],
            fadeInDuration: 2,
            fadeOutDuration: 2,
        },
    ]
};
